@if (!hasValidSeries()) {
  <!-- A line needs at least two valid data points to render. -->
  <span class="spark-empty" title="Няма достатъчно данни">—</span>
} @else if (isBrowser) {
  <div echarts [options]="options()" class="spark" aria-hidden="true"></div>
} @else {
  <div class="spark" aria-hidden="true"></div>
}
